import url from './url';



export default url(() => '/ab-tests/create');

